<h1 mat-dialog-title>Edit Avatar</h1>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <div class="avatar-options">
    <div>
      <h5>Custom</h5>
      <div #customAvatar matRipple
        [ngClass]="{ 'selected': selectedOption === avatarOptions.custom }"
        attr.data-value="{{ avatarOptions.custom }}"
        test-id="custom-option"
        (click)="selectAvatar($event)">
        <div *ngIf="useBlankAvatar" class="blank-avatar"><mat-icon>person</mat-icon></div>
        <img *ngIf="!useBlankAvatar" [src]="customAvatarField.value" (error)="onImageSrcError()">
      </div>
    </div>
    <div *ngIf="avatars.gravatar">
      <h5>Gravatar</h5>
      <div #gravatarAvatar matRipple
        [ngClass]="{ 'selected': selectedOption === avatarOptions.gravatar }"
        attr.data-value="{{ avatarOptions.gravatar }}"
        test-id="gravatar-option"
        (click)="selectAvatar($event)">
        <img *ngIf="avatars.gravatar" [src]="avatars.gravatar" (error)="onGravatarSrcError()">
      </div>
    </div>
    <div *ngIf="avatars.provider">
      <h5>Provider</h5>
      <div #providerAvatar matRipple
        [ngClass]="{ 'selected': selectedOption === avatarOptions.provider }"
        attr.data-value="{{ avatarOptions.provider }}"
        test-id="provider-option"
        (click)="selectAvatar($event)">
        <div *ngIf="!avatars.provider" class="blank-avatar"><mat-icon>person</mat-icon></div>
        <img *ngIf="avatars.provider" [src]="avatars.provider">
      </div>
    </div>
  </div>
  <mat-form-field appearance="outline" test-id="custom-avatar-url">
    <input type="url" matInput [formControl]="customAvatarField">
    <mat-error *ngIf="customAvatarField.errors?.required">Image address is required.</mat-error>
    <mat-error *ngIf="customAvatarField.errors?.pattern">Enter a valid address.</mat-error>
    <mat-error *ngIf="customAvatarField.errors?.imageNotFound">Image not found.</mat-error>
  </mat-form-field>
  <hr>
  <div style="margin-bottom: 5px;">
    <button mat-flat-button test-id="avatar-save-button" (click)="saveAvatar()" color="primary" [disabled]="customAvatarField.invalid">
      Save
    </button>
    <button mat-flat-button test-id="avatar-cancel-button" (click)="cancelAvatar()">
      Cancel
    </button>
  </div>
</div>
